import {Component, OnInit, ViewChild} from '@angular/core';
import {EventsService} from '../../events.service';
import {Router, ActivatedRoute, NavigationEnd} from '@angular/router';
import {isPlatformBrowser} from "@angular/common";
import {
  PerfectScrollbarConfigInterface,
  PerfectScrollbarComponent,
  PerfectScrollbarDirective
} from 'ngx-perfect-scrollbar';
import {GlobalService} from "../../../global.service";
import {Title} from "@angular/platform-browser";
// declare const initsnow: any;

@Component({
  selector: 'app-christmas',
  templateUrl: './christmas.component.html',
  styleUrls: ['./christmas.component.css']
})
export class ChristmasComponent implements OnInit {

  mobileView: boolean = false;
  public config: PerfectScrollbarConfigInterface = {
    // suppressScrollX:true
  };
  @ViewChild(PerfectScrollbarComponent) componentRef?: PerfectScrollbarComponent;
  @ViewChild(PerfectScrollbarDirective) directiveRef?: PerfectScrollbarDirective;

  games: Array<any> = ['rainbow-six-siege', 'crossfire', 'fortnite', 'pubg', 'league-of-legends'];
  constructor(private globalService:GlobalService,private router: Router, private activeRoute: ActivatedRoute, public eventService: EventsService ,private titleService:Title) {
    this.titleService.setTitle('Christmas 2019')
    if (this.globalService.isBrwoser) {
      if (window.screen.width < 768) {
        this.mobileView = true;
      }
    }
  }

  ngOnInit() {
    this.eventService.insomniaGame = this.router.url.split('/')[2];
    // initsnow();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        this.eventService.insomniaGame = event.url.split('/')[2];
      }
    });
    if (this.router.url.split('/').length < 3) {
      this.router.navigateByUrl('/christmas/rainbow-six-siege');
    }
  }


}
